export function loginNav () {
  const navElLogin = document.querySelectorAll('.login__nava');
  const loginBox = document.querySelectorAll('.login__box');
  const loginButton = document.querySelector('.login__submit');
  const allSection = document.querySelectorAll('section');

  navElLogin.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const href = e.currentTarget.getAttribute('href').slice(1);
      const classTarget = `.login__box--${href}`;

      navElLogin.forEach((nav) => {
        nav.parentElement.classList.remove('login__navel--active');
      });

      e.currentTarget.parentElement.classList.add('login__navel--active');

      loginBox.forEach((box) => {
        box.classList.remove('login__box--visible');
      });

      document.querySelector(classTarget).classList.add('login__box--visible');
    });
  });

  loginButton.addEventListener('click', (e) => {
    e.preventDefault();
    const connection = document.querySelector('.homepage');
    allSection.forEach((el) => {
      el.classList.remove('visible');
    });
    connection.classList.add('visible');
  });
}
